import { DatePicker } from "./DatePicker";

export const FilterDateSelector = ({
    setFilters,
    selectedDateField,
    dateTypeMetadata,
    filters,
}) => {
    return (
        <>
            {dateTypeMetadata.map((item) => {
                const filter = filters.find((el) => el.name === item.name);
                return (
                    <DatePicker
                        key={item.name}
                        name={item.name}
                        filter={filter}
                        setFilters={setFilters}
                        selectedDateField={selectedDateField}
                    />
                );
            })}
        </>
    );
};
